document.documentElement.classList.remove('no-js');
(function () {
  function setMenu(button, open) {
    var menu = document.getElementById(button.getAttribute('aria-controls'));
    if (!menu) return;
    button.setAttribute('aria-expanded', String(open));
    menu.classList.toggle('is-open', open);
  }
  function closeMenus(focus) {
    document.querySelectorAll('[data-mobile-toggle][aria-expanded="true"]').forEach(function (button) {
      setMenu(button, false);
      if (focus) button.focus();
    });
  }
  document.addEventListener('click', function (event) {
    if (!(event.target instanceof Element)) return;
    var poster = event.target.closest('deferred-media > button');
    if (poster && !window.customElements.get('deferred-media')) {
      var media = poster.parentElement;
      var template = media.querySelector('template');
      if (template && !media.hasAttribute('loaded')) {
        media.appendChild(template.content.cloneNode(true));
        media.setAttribute('loaded', '');
        var player = media.querySelector('video, iframe');
        if (player) player.focus();
        if (player instanceof HTMLVideoElement) player.play().catch(function () {});
      }
    }
    var button = event.target.closest('[data-mobile-toggle]');
    if (button) {
      setMenu(button, button.getAttribute('aria-expanded') !== 'true');
    } else if (event.target.closest('[data-mobile-nav] a') || !event.target.closest('.nav-wrap')) {
      closeMenus(false);
    }
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeMenus(true);
  });
  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width:981px)').matches) closeMenus(false);
  });
  document.addEventListener('change', function (event) {
    if (!(event.target instanceof Element)) return;
    var select = event.target.closest('[data-variant-select]');
    if (!select) return;
    var product = select.closest('.heritage-product');
    var option = select.selectedOptions[0];
    if (!product || !option) return;
    var price = product.querySelector('[data-variant-price]');
    var compare = product.querySelector('[data-variant-compare]');
    if (price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    var url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  });
})();
